import React, { useState, useEffect, useRef, useCallback } from 'react';
import './scss/ProductImageSlider.scss'
//icon
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';

export default function ProductImageSlider(props){
    const sliderWidth = useRef(null);
    //slider
    const [currentIndex, setCurrentIndex] = useState(0);
    const [translateValue, setTranslateValue] = useState(0);
    //selector
    const [sCurrentIndex, setSCurrentIndex] = useState(0);
    const [sTranslateValue, setSTranslateValue] = useState(0);

     //useCall back to resize
     const handleResize = useCallback(
        ()=>{
            setTranslateValue(sliderWidth.current.offsetWidth*currentIndex);
        },[currentIndex]
    )

    useEffect(()=>{
        //set resize
        window.addEventListener("resize", handleResize);
        //set translate value
        setTranslateValue(sliderWidth.current.offsetWidth*currentIndex);
        setSTranslateValue(sliderWidth.current.offsetWidth*sCurrentIndex);

        return ()=>{
            //remove all handler
            window.removeEventListener("resize", handleResize);
        }
    },[handleResize, currentIndex, sCurrentIndex, props.images])

    const imageList = props.images.map((image,index)=>(
        <div className="slide" key={index} style={{backgroundImage:`url(${image})`}}>
        
        </div>
    ))

    const selectorList = props.images.map((image,index)=>(
        <div className={currentIndex===index ? 'select active' : 'select'} key={index} onClick={()=>setCurrentIndex(index)} >
            <img src={image} alt={image} />
        </div>
    ))

    //go to select next slide
    function goSelectNext(){
        if(props.images.length>(sCurrentIndex+1)*5){
            setSCurrentIndex(sCurrentIndex+1);
        }

    }

    //go to select prev slide
    function goSelectPrev(){
        if(sCurrentIndex>0){
            setSCurrentIndex(sCurrentIndex-1)
        }
    }

    //go to next slide
    function goNext(){
        if(currentIndex>=props.images.length-1){
            setCurrentIndex(0);
        }else{
            setCurrentIndex(currentIndex+1);
        }
    }

    //go to prev slide
    function goPrev(){
        if(currentIndex<=0){
            setCurrentIndex(props.images.length-1);
        }else{
            setCurrentIndex(currentIndex-1);
        }
    }
    
    return(
        <div>

            <div className="product-image-slider">
                <div className="wrapper" ref={sliderWidth} style={{transform: `translateX(-${translateValue}px)`}}>
                    {imageList}
                </div>
                <div className="arrow" onClick={()=>goPrev()} style={{left:0}}>
                    <KeyboardArrowLeftIcon />
                </div>
                <div className="arrow" onClick={()=>goNext()} style={{right:0}}>
                    <KeyboardArrowRightIcon />
                </div>
                
            </div>
            <div className="slide-selector" >
                <div className="wrapper" style={{transform: `translateX(-${sTranslateValue}px)`}}>
                    {selectorList}
                </div>
                <div className="select-arrow" onClick={()=>goSelectPrev()} style={{left:0}}>
                    <KeyboardArrowLeftIcon />
                </div>
                <div className="select-arrow" onClick={()=>goSelectNext()} style={{right:0}}>
                    <KeyboardArrowRightIcon />
                </div>
            </div>
           
                    
        </div>
    )
}